import * as React from 'react';
import Avatar from 'antd/lib/avatar/avatar';
import { getAvatarColorForName } from './styles/globalStyles';

interface AvatarProps {
    size?: number;
    user: string;
    style: React.CSSProperties;
    children: React.ReactNode;
}

const IntegrationAvatar: React.FC<AvatarProps> = (props: AvatarProps) => {
    const { size = 'default', user, style, children } = props;

    const baseStyle: React.CSSProperties = {
        backgroundColor: getAvatarColorForName(user),
    };

    return (
        <Avatar size={size} style={{ ...baseStyle, ...style }}>
            {children}
        </Avatar>
    );
};

export default IntegrationAvatar;
